/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/nlp-integration-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/nlp-integration-api-client";
import type { GetLiveTopicsTopicByIdQueryResponse, GetLiveTopicsTopicByIdPathParams } from "../models/GetLiveTopicsTopicById";

export function getGetLiveTopicsTopicByIdUrl(slug: GetLiveTopicsTopicByIdPathParams["slug"], topicId: GetLiveTopicsTopicByIdPathParams["topicId"]) {
  const res = { method: 'GET', url: `/live-topics/${slug}/topics/${topicId}` as const }
  return res
}

/**
 * @description Fetch a single topic by id for the given channel slug.
 * @summary Get topic by id
 * {@link /live-topics/:slug/topics/:topicId}
 */
export async function getLiveTopicsTopicById(slug: GetLiveTopicsTopicByIdPathParams["slug"], topicId: GetLiveTopicsTopicByIdPathParams["topicId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetLiveTopicsTopicByIdQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getGetLiveTopicsTopicByIdUrl(slug, topicId).url.toString(), ... requestConfig })
  return res.data
}